import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-3" }, [
  /*#__PURE__*/_createTextVNode("NIP pracodawcy "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "flex flex-col md:flex-row items-start justify-start w-full" }
const _hoisted_4 = { class: "w-full gap-3 flex flex-col items-start justify-start" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "absolute top-[28px] lg:top-[36px] right-0 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "flex flex-shrink-0 items-center justify-center w-[48px] h-[48px] rounded-full bg-primary/10" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "1-Home",
        transform: "translate(-794, -4365)",
        fill: "#1434A4",
        "fill-rule": "nonzero"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          id: "Group-8",
          transform: "translate(304, 4047)"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "accordion",
            transform: "translate(0, 300)"
          }, [
            /*#__PURE__*/_createElementVNode("g", {
              id: "icon",
              transform: "translate(472, 0)"
            }, [
              /*#__PURE__*/_createElementVNode("g", {
                id: "ui/plus",
                transform: "translate(18, 18)"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  d: "M10,20 C8.34389511,19.9981923 7.00180771,18.6561049 7,17 L7,15.92871 C7,15.3764253 7.44771525,14.92871 8,14.92871 C8.55228475,14.92871 9,15.3764253 9,15.92871 L9,17 C9,17.5522847 9.44771525,18 10,18 C10.5522847,18 11,17.5522847 11,17 L11,12 C11,11.4477153 11.4477153,11 12,11 L17,11 C17.5522847,11 18,10.5522847 18,10 C18,9.44771525 17.5522847,9 17,9 L12,9 C11.4477153,9 11,8.55228475 11,8 L11,3 C11,2.44771525 10.5522847,2 10,2 C9.44771525,2 9,2.44771525 9,3 L9,8 C9,8.55228475 8.55228475,9 8,9 L3,9 C2.44771525,9 2,9.44771525 2,10 C2,10.5522847 2.44771525,11 3,11 L7.92871,11 C8.48099475,11 8.92871,11.4477153 8.92871,12 C8.92871,12.5522847 8.48099475,13 7.92871,13 L3,13 C1.34314575,13 0,11.6568542 0,10 C0,8.34314575 1.34314575,7 3,7 L7,7 L7,3 C7,1.34314575 8.34314575,0 10,0 C11.6568542,0 13,1.34314575 13,3 L13,7 L17,7 C18.6568542,7 20,8.34314575 20,10 C20,11.6568542 18.6568542,13 17,13 L13,13 L13,17 C12.9981923,18.6561049 11.6561049,19.9981923 10,20 L10,20 Z",
                  id: "Path"
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-[17px] text-textBlack leading-[20px] ml-5" }, " Dodaj kolejny NIP (opcjonalne) ", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import { ErrorMessage, Field, useFieldArray } from 'vee-validate';
import DeleteItemButton from '../MedicationChoose/components/DeleteItemButton.vue';
import { onMounted } from 'vue';


export default {
  __name: 'NIPField',
  setup(__props) {

const { fields, remove, push } = useFieldArray('nip');

onMounted(() => {
    if (fields.value.length === 0) {
        push({ value: '' });
    }
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "w-full flex flex-col items-start md:flex-row md:items-center md:justify-start relative",
            key: field.key
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Field), {
                name: `nip[${idx}].value`,
                rules: "required"
              }, {
                default: _withCtx(({ errors, field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    type: "text",
                    class: ["form-input !mt-0", {
                                    'border-[1px] !border-error border-solid': errors.length,
                                    'border-none': !errors.length,
                                }],
                    placeholder: "Wprowadź NIP pracodawcy"
                  }), null, 16)
                ]),
                _: 2
              }, 1032, ["name"]),
              _createVNode(_unref(ErrorMessage), {
                name: `nip[${idx}].value`,
                class: "error-message block text-[15px]"
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (!field.isFirst)
                ? (_openBlock(), _createBlock(DeleteItemButton, {
                    key: 0,
                    onDeleteItem: () => _unref(remove)(idx),
                    id: idx
                  }, null, 8, ["onDeleteItem", "id"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => (_unref(push)({ value: '' }))),
        class: "ml-0 md:ml-4 mt-3 flex items-center justify-center"
      }, _hoisted_9)
    ])
  ]))
}
}

}